<template>
  <el-slider
    show-input
    v-model="modelValue"
    class="ticket_form_slider"
    @change="onChange"/>
</template>

<script>
export default {
    name : 'TicketFormSlider',

    props : ['value', 'item'],

    data() {
      return {
        modelValue : null
      }
    },

    watch : {
      value() {
        // console.log('#23 watch', this.value, this.modelValue);

        this.modelValue = Number(this.value);
      }
    },

    mounted() {
      // console.log('#29 mounted', this.value, this.modelValue);

      this.modelValue = Number(this.value);
    },

    methods : {
      onChange() {
        this.$emit('input', this.modelValue);

        this.$emit('change', this.modelValue);
      }
    }
}
</script>

<style>
  .ticket_form_slider {
    padding-left: 8px;
    top: 1px;
    position: relative;
  }

  .ticket_form_slider .el-input-number {
    line-height: 30px;
    width: 130px;
  }

  .ticket_form_slider .el-input__inner {
    text-align: center!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketFormSlider.vue